import ColorSkin from "./ColorSkin";
import Language from "./Language";
import MaritalState from "./MaritalState";
import Nationality from "./Nationality";
import Sex from "./Sex";

export default class Professional {

    Id: string;
    Name: string;
    CPF: string | undefined;
    EncriptId: string | undefined;
    BirthDate: Date | undefined;
    RG: string | undefined;
    IssuingAgency: string | undefined;
    CRM: string | undefined;
    IdMaritalStatus: number | undefined;
    MaritalState: MaritalState | undefined;
    IdNationality: number | undefined;
    Nationality: Nationality | undefined;
    IdColorSkin: number | undefined;
    ColorSkin: ColorSkin | undefined;
    IdSex: string | undefined;
    Sex: Sex | undefined;
    FatherName: string | undefined;
    PartnerName: string | undefined;
    MotherName: string | undefined;
    UsualName: string | undefined;
    TelephonePhone: string | undefined;
    BusinessPhone: string | undefined;
    CellPhone: string | undefined;
    Email: string | undefined;
    TasyCode: string | undefined;
    LanguageIds: number[] | undefined;
    Languages: Language[] | undefined;

    constructor(id: string, name: string) {
        this.Id = id;
        this.Name = name;
    }

    static NewInstance() {
        return new Professional("", "");
    }
}